export default "__VITE_ASSET__ElA13Inc__"